export default "__VITE_PUBLIC_ASSET__1082f82d__"